import { ERequestsAndOperationsESActions, RequestsOperationsESActions } from "@edp-store/actions/ES/request-operations-es.actions";
import { IRequestsOperationsESState, initialRequestOperationsESState } from "@edp-store/state/ES/resquest-operations-es.state";

export function RequestsOperationsESReducers(
    state = initialRequestOperationsESState,
    action: RequestsOperationsESActions
): IRequestsOperationsESState {
    switch (action.type) {
        case ERequestsAndOperationsESActions.SetRequestsAndOperations: {
            return {
                ...state,
                eSrequestsAndOperations: action.payload,
            };
        }
        case ERequestsAndOperationsESActions.SetLoadedServices: {
            return {
                ...state,
                eSloadedServices: action.payload,
            };
        }
        case ERequestsAndOperationsESActions.SetFilters: {
            return {
                ...state,
                eSfilters: action.payload,
            };
        }
        case ERequestsAndOperationsESActions.EsSetServices: {
            return {
                ...state,
                eSservices: action.payload,
            };
        }
        case ERequestsAndOperationsESActions.SetLoadedSlots: {
            return {
                ...state,
                eSloadedSlots: action.payload,
            };
        }
        case ERequestsAndOperationsESActions.SetAvailableTimeSlots: {
            return {
                ...state,
                eSavailableTimeSlots: {
                    data: action.payload,
                    lastAPIError: null,
                },
            };
        }
        case ERequestsAndOperationsESActions.SetRequestsAndOperationsDetails: {
            return {
                ...state,
                eSselectedRequest: action.payload,
            };
        }
        case ERequestsAndOperationsESActions.SetSelectedServiceAndMotive: {
            return {
                ...state,
                eSselectedServiceAndMotive: action.payload,
            };
        }
        case ERequestsAndOperationsESActions.SetNewRequestStatus: {
            return {
                ...state,
                eSnewRequestStatus: action.payload,
            };
        }

        default: {
            return state;
        }
    }
}
